import React, { memo, useCallback } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import style from './showNotification.module.scss';
import { LABEL } from '@veriables';
import TimeConverter from '@components/common/TimeConverter';
import { TouchableDiv } from '@components/common/Touchable';
import { ReactComponent as NotificationSuccess } from '@assets/images/notificationIcons/notificationSuccess.svg';
import { ReactComponent as NotificationError } from '@assets/images/notificationIcons/notificationError.svg';
import { ReactComponent as NotificationIcon } from '@assets/images/notificationIcons/notificationIcon.svg';

const SeverityIcon = memo(({ severity }) => {
  if (severity === 0 || severity === 1) {
    return (
      <NotificationSuccess
        style={{ background: '#028604', borderRadius: '4px' }}
      />
    );
  }
  if (severity === 2) {
    return (
      <NotificationError
        style={{ background: '#EB5252', borderRadius: '4px' }}
      />
    );
  }
  return (
    <NotificationIcon style={{ background: '#FFCC00', borderRadius: '4px' }} />
  );
});

const selectNotificationById = (id) => (state) =>
  state.storeNotifications.storeNotification.find((n) => n.id === id);

const NotificationRow = memo(({
  id,
  isLandScape,
  notificationStyle,
  dismissStyle,
  notificationColor,
  acknowledgedStyle,
  onDismiss,
  onAcknowledge,
}) => {
  const item = useSelector(selectNotificationById(id));
  const handleDismiss = useCallback(() => onDismiss(id), [id, onDismiss]);
  const handleAcknowledge = useCallback(() => onAcknowledge(id), [id, onAcknowledge]);

  if (!item) return null;

  return (
    <div style={isLandScape ? undefined : { paddingBottom: '1rem' }}>
      <div
        className={cn(isLandScape ? `${style.notificationCard} py-2` : 'py-12')}
        style={notificationStyle}
      >
        {isLandScape ? (
          <div className="mx-0 fw-500 fs_16 px-2">
            <div className="d-flex">
              <div className={cn('pr-2 text-center')}>
                <SeverityIcon severity={item?.severity} />
              </div>
              <div className={cn('col text-left pr-2 pl-0')}>{item.note}</div>
            </div>
            <div className="d-flex align-items-center justify-content-between">
              <div className={cn('col-2 px-2 fs_12')} style={notificationColor}>
                <TimeConverter date={item.openDate} />
              </div>
              <div className="d-flex">
                <TouchableDiv
                  role="presentation"
                  onClick={handleDismiss}
                  className={cn('text-center fs_12', style.dismissBtn)}
                  rippleEffect={true}
                >
                  <button style={dismissStyle}>{LABEL().NS_DISMISS}</button>
                </TouchableDiv>
                <TouchableDiv
                  role="presentation"
                  onClick={handleAcknowledge}
                  className={cn('text-center fs_12 ml-1', style.acknowledgeBtn)}
                  rippleEffect={true}
                >
                  <button style={acknowledgedStyle} className="border-0">
                    {LABEL().NS_ACKNOWLEDGED}
                  </button>
                </TouchableDiv>
              </div>
            </div>
          </div>
        ) : (
          <div className="mx-0 fw-500 fs_14 px-12">
            <div className="d-flex">
              <div className={cn('pr-2 text-center')}>
                <SeverityIcon severity={item?.severity} />
              </div>
              <div className={cn('pr-2 text-left fs_14 fw-500 pb-3 pl-0')}>
                {item.note}
              </div>
            </div>
            <div className="d-flex align-items-center justify-content-between">
              <div
                className={cn('text-right px-2 fs_12')}
                style={notificationColor}
              >
                <TimeConverter date={item.openDate} />
              </div>
              <div className="d-flex">
                <TouchableDiv
                  role="presentation"
                  onClick={handleDismiss}
                  className={cn('text-center fs_12', style.dismissBtn)}
                  rippleEffect={true}
                >
                  <button style={dismissStyle}>{LABEL().NS_DISMISS}</button>
                </TouchableDiv>
                <TouchableDiv
                  role="presentation"
                  onClick={handleAcknowledge}
                  className={cn('text-center fs_12', style.acknowledgeBtn)}
                  rippleEffect={true}
                >
                  <button style={acknowledgedStyle} className="border-0">
                    {LABEL().NS_ACKNOWLEDGED}
                  </button>
                </TouchableDiv>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
});

export default NotificationRow;
